import React, { Component } from "react";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSignOutAlt} from "@fortawesome/free-solid-svg-icons";
import {connect} from "react-redux";
import {logoutUser} from "../../actions/authActions";
import $ from 'jquery';

class Footer extends Component {
   constructor(props) {
      super(props);
      this.state = {
       appview:true,
      };    
       clearInterval();
      // window.location.reload();
  }
   componentDidMount() { 
      // console.log("this.props.history.location.search=",window.location.search);
      const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });
      let source = params.source;
      if(source==='mobile'){
         this.setState({appview:false});
      }
   }
    onLogoutClick = e => {
        e.preventDefault();
        this.props.logoutUser();
    };

    render() {
        const { user } = this.props.auth;
        return (
         <>
           {this.state.appview && <footer className="footer">
          
           <div className="container">
              <div className="row text-start justify-content-lg-between mb-5 mb-lg-0">
                 <div className="col-md-6">
                    <ul className="fLinks privacy">
                       <li><a href="https://3-verse.io/privacy-policy">Privacy Policy</a></li>
                       <li><a href="https://3-verse.io/terms">Terms of Use</a></li>
                       <li><a href="https://3-verse.io/disclaimer">Disclaimer</a></li>
                    </ul>
                    <h6  className="copyright">3verse © 2022</h6>
                 </div>
                 <div  className="col-lg-6 col-md-6 bottomSocial">
                    
                    <ul  className="pt-3">
                       <li ><span>Follow us on</span></li>
                       <li ><a  target="_blank" className="facebook" href="https://www.facebook.com/100086196572874">Facebook</a></li>
                       <li ><a  target="_blank" className="insta" href="https://www.instagram.com/real3verse">Instagram</a></li>
                       <li ><a  target="_blank" className="twitter" href="https://twitter.com/real3Verse">Twitter</a></li>
                       <li ><a  target="_blank" className="linkedinft" href="https://www.linkedin.com/company/real3verse">Linkedin</a></li>
                       <li ><a  target="_blank" className="redit" href="https://www.reddit.com/user/real3verse">Reddit</a></li>
                       {/* <li ><a  target="_blank" className="pinterest" href="https://www.pinterest.com/realcryptowire/">Pinterest</a></li> */}
                       <li ><a  target="_blank" className="quara" href="https://www.quora.com/profile/Real3Verse">Quora</a></li>
                       <li ><a  target="_blank" className="youtube" href="https://youtube.com/channel/UCAucb7t2m8Y9Mx_DOZU6YKQ">Youtube</a></li>
					    <li ><a  className="discord" href="https://discord.gg/73gusC4AEd">Discord</a></li>
                    </ul>
                 </div>
              </div>
           </div>
            </footer>
            }
            </>
        );        
    }
}

Footer.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(
    mapStateToProps,
    { logoutUser }
)(Footer);
